import React from 'react';
import { Chip, ChipSize } from '@amzn/atoz-web/Chip';
import { Text } from '@amzn/atoz-web/Text';
import { useShiftIntervalMapping } from '../../../../hooks/useShiftIntervalMapping/useShiftIntervalMapping.web';
import { IconSize } from '@amzn/atoz-web/Icons';
import { View } from '@amzn/atoz-web/View';
export var ShiftIntervalBlock = function (_a) {
    var category = _a.category, blockName = _a.blockName, blockContent = _a.blockContent;
    var _b = useShiftIntervalMapping(category), icon = _b.icon, chipColor = _b.color.chipColor;
    var styledIcon = React.cloneElement(icon, {
        margin: { right: 'S100', left: 'S100' },
        size: IconSize.Small
    });
    return (React.createElement(View, { dataTestId: "ShiftIntervalBlock", role: "listitem" },
        React.createElement(Chip, { icon: styledIcon, backgroundColor: chipColor, size: ChipSize.Small },
            React.createElement(Text, { fontSize: "T100" },
                React.createElement(Text, { fontSize: "T100", fontWeight: "bold", display: "inline" }, blockName),
                ' ',
                blockContent))));
};
